import React from 'react';
import Box from '../box';
import { useStyleConfig, v, vui } from '../core';
import { cs, isJsx } from '../utils';
import { useFooterContext } from './context';
import FooterHeading from './footerHeading';
import FooterLink from './footerLink';
/** Section includes a heading and a set of links. */
export const FooterSection = vui((props, ref) => {
    const { children, className, heading, links, ...rest } = props;
    const styles = useStyleConfig('Footer', useFooterContext());
    return (React.createElement(Box, { className: cs('vui-footerSection', className), column: true, ref: ref, ...styles.section, ...rest },
        isJsx(heading) ? heading : React.createElement(FooterHeading, { text: heading }),
        children ??
            (isJsx(links) ? (links) : (React.createElement(v.ul, null, links?.map(({ text, url }, index) => (React.createElement(v.li, { key: index },
                React.createElement(FooterLink, { href: url, text: text })))))))));
});
export default FooterSection;
